const getPeriodRange = (year: number, periodNumber: number, frequency: number = 3): any => {
  let endMonth = periodNumber * frequency - 1;
  let startMonth = endMonth - frequency + 1;

  const rangeObject = {
    startDate: new Date(year, startMonth, 1),
    endDate: new Date(year, endMonth + 1, 0),
  };
  return rangeObject;
};

export default getPeriodRange;
